"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.yupResolver = void 0;
const react_hook_form_1 = require("react-hook-form");
const parseErrorSchema = (error, validateAllFieldCriteria) => Array.isArray(error.inner) && error.inner.length
    ? error.inner.reduce((previous, { path, message, type }) => {
        const previousTypes = (previous[path] && previous[path].types) || {};
        const key = path || type;
        return Object.assign(Object.assign({}, previous), (key
            ? {
                [key]: Object.assign(Object.assign({}, (previous[key] || {
                    message,
                    type,
                })), (validateAllFieldCriteria
                    ? {
                        types: Object.assign(Object.assign({}, previousTypes), { [type]: previousTypes[type]
                                ? [...[].concat(previousTypes[type]), message]
                                : message }),
                    }
                    : {})),
            }
            : {}));
    }, {})
    : {
        [error.path]: { message: error.message, type: error.type },
    };
const yupResolver = (schema, options = {
    abortEarly: false,
}) => async (values, context, validateAllFieldCriteria = false) => {
    try {
        if (options.context &&
            process.env.NODE_ENV === 'development') {
            // eslint-disable-next-line no-console
            console.warn("You should not used the yup options context. Please, use the 'useForm' context object instead");
        }
        return {
            values: (await schema.validate(values, Object.assign(Object.assign({}, options), { context }))),
            errors: {},
        };
    }
    catch (e) {
        const parsedErrors = parseErrorSchema(e, validateAllFieldCriteria);
        return {
            values: {},
            errors: react_hook_form_1.transformToNestObject(parsedErrors),
        };
    }
};
exports.yupResolver = yupResolver;
//# sourceMappingURL=yup.js.map